"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_STATS = void 0;
const client_1 = require("@apollo/client");
exports.PRODUCT_STATS = (0, client_1.gql) `
  query ProductStats($entitlementId: [Int!]) {
    restricted {
      productStats(entitlementId: $entitlementId) {
        totalQuestions
        completedQuestions
        correctQuestions
        incorrectQuestions

        redCards
        totalCards
        greenCards
        yellowCards
        dailyFeedCards

        types {
          id
          name
          index
          totalQuestions
          completedQuestions
          correctQuestions
          incorrectQuestions

          redCards
          totalCards
          greenCards
          yellowCards
          dailyFeedCards
        }
      }
    }
  }
`;
